import { render, staticRenderFns } from "./PartyItem.vue?vue&type=template&id=63ce9f10&"
import script from "./PartyItem.vue?vue&type=script&lang=ts&"
export * from "./PartyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports